import { Injectable, Signal } from '@angular/core';
import { createFilterOptions } from '@modules/filter/utils/filter-options';
import { CreateFilterOptions, FilterList } from '@type/filter.type';

@Injectable()
export abstract class FilterFieldsService {
  protected showCheckboxForEmptyValue = true;

  protected cacheDictionary = true;

  protected showNotEmptyCheckboxForFilters = [];

  abstract fields: Signal<FilterList>;

  getOptions(): CreateFilterOptions {
    return createFilterOptions({
      showCheckboxForEmptyValue: this.showCheckboxForEmptyValue,
      showCheckboxForFilledValueForFilters: this.showNotEmptyCheckboxForFilters,
      cacheDictionary: this.cacheDictionary,
      rows: [{ name: 'fields', fields: this.fields() }],
    });
  }
}
